import React from 'react';
import styled from 'styled-components';

const TrialMeter = props => {
  const { flowPercentage, small, color } = props;

  return (
    <FlowMeter small={small}>
      <FlowProgress complete={flowPercentage} color={color} />
    </FlowMeter>
  );
};

TrialMeter.defaultProps = {
  color: '$purple',
};

const FlowMeter = styled.div`
  display: inline-block;
  background-color: ${props => props.theme['$gray-20']};
  border-radius: 5px;
  height: ${props => (props.small ? '4px' : '10px')};
  overflow: hidden;
  margin-bottom: 5px;
  width: 100%;
`;

const FlowProgress = styled.div`
  background-color: ${props => props.theme[props.color]};
  width: ${props => `${props.complete}%`};
  height: 100%;
`;

export default TrialMeter;
